
import { TSX, Component, Prop, Vue, Watch } from 'vue-facing-decorator'
interface Props {
  options: any
}

@Component({})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop()
  options: any;

  /**
   * 口径和后端 OrderEntity.mesureAmount 对齐：
   * Σ(原小计 + 改价) + 运费 - 店铺优惠，最后不小于 0。
   * 订单上已经没有 changeAmount 这个字段了，改价挂在每个 orderGoods 行上
   */
  get payAmount() {
    let cents = (this.orderInfo.orderGoods || []).reduce((prev, item) => {
      return prev
        + this.toCents(item.price) * this.toNumber(item.num)
        + this.toCents(item.changeAmount);
    }, 0);
    cents += this.toCents(this.ruleForm.expressAmount);
    cents -= this.toCents(this.orderInfo.discountAmount);
    return (Math.max(cents, 0) / 100).toFixed(2);
  }

  /** 原小计 = 原单价 × 数量，不含改价；改价单独一列，看账更清楚 */
  rowTotal(row) {
    return (this.toCents(row.price) * this.toNumber(row.num) / 100).toFixed(2);
  }

  /**
   * 减价最多把这一行减到 0，不能减成负数 ——
   * 后端也是这个口径（商品行总价不能小于0），先在这里拦住省一次往返
   */
  rowError(row) {
    let totalCents = this.toCents(row.price) * this.toNumber(row.num) + this.toCents(row.changeAmount);
    if (totalCents < 0) {
      return `最多只能减 ${this.rowTotal(row)}`;
    }
    return "";
  }

  /** 输入框里可能是空串或非法值，统一转成数字 */
  toNumber(v) {
    let num = parseFloat(v);
    return isNaN(num) ? 0 : num;
  }

  /**
   * 金额一律按「分」做整数运算：
   * 后端 @IsNumber({maxDecimalPlaces: 2}) 是按数字字面量校验的，
   * 留个 0.6000000000000001 这类浮点尾巴就直接校验不过
   */
  toCents(v) {
    return Math.round(this.toNumber(v) * 100);
  }

  /** 提交用的金额：按分四舍五入后转回元 */
  toAmount(v) {
    return Number(this.toNumber(v).toFixed(2));
  }

  get title() {
    return `订单原价(含运费)：${this.orderInfo.originAmount || ""} 元`;
  }

  async getData() {
    let { error, data } = await this.$post("/manager/order/view", {
      id: this.options.id,
    });
    if (error) return;
    /** 改价金额现在挂在每个 orderGoods 行上，订单上已经没有这个字段了 */
    this.ruleForm.expressAmount = data.expressAmount;
    this.orderInfo = data;
  }

  async submitForm() {
    let badRow = (this.orderInfo.orderGoods || []).find((item) => this.rowError(item));
    if (badRow) {
      let name = (badRow.goodsDetails && badRow.goodsDetails.name) || "商品";
      return this.$error(`${name}：${this.rowError(badRow)}`);
    }

    let goodsList = (this.orderInfo.orderGoods || []).map((item) => {
      return {
        id: item.id,
        changeAmount: this.toAmount(item.changeAmount),
      };
    });
    let { error, message } = await this.$post("/manager/order/modify-price", {
      id: this.options.id,
      expressAmount: this.toAmount(this.ruleForm.expressAmount),
      goodsList,
    });
    if (error) return this.$error(message);
    this.$emit('resolve', []);
  }

  async created() {
    this.loaindg = true;
    await this.getData();
    this.loaindg = false;
  }

  loaindg = false
  orderInfo: any = {}

  ruleForm = {
    expressAmount: "",
  }
}
